import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom"; // Import useSearchParams
import PersonalInfoForm from "./profile";
import SecuritySettings from "./security";
import { setBreadcrumbs } from "../../../redux/Admin/breadcrumbsSlice";
import { useDispatch } from "react-redux";
import Heading from "../../../common/element/Heading";

const Setting = () => {
  const dispatch = useDispatch();
  
  // 1. Hook to read and write URL query parameters (?tab=...)
  const [searchParams, setSearchParams] = useSearchParams();

  // 2. Get the current tab from URL, default to 'profile' if missing
  const activeTabFromUrl = searchParams.get("tab");
  const tabs = [
    { key: "profile", label: "Your profile" },
    { key: "security", label: "Security" },
  ];

  // 3. Validate logic: If URL has garbage (e.g. ?tab=xyz), default to 'profile'
  const currentTab = tabs.some((t) => t.key === activeTabFromUrl)
    ? activeTabFromUrl
    : "profile";

  // 4. Update Breadcrumbs when tab changes
  useEffect(() => {
    dispatch(
      setBreadcrumbs([
        { label: "Settings", url: "/setting?tab=profile" },
        { 
          label: currentTab === "security" ? "Security" : "Your Profile", 
          url: `/setting?tab=${currentTab}`,
          active: true
        }
      ])
    );
  }, [dispatch, currentTab]);

  // 5. Handler to update URL when clicking a tab
  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  return (
    <div className="w-full bg-white rounded-lg h-full">
      <div className="w-80 h-10 text-start mb-4">
        <Heading>Settings</Heading>
      </div>
      
      {/* Tabs - Pill Shape */}
      <div className="flex bg-[#FFF4E5] p-1 rounded-lg w-full mb-8">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`flex-1 py-2.5 rounded-md text-sm font-medium transition-all duration-200
              ${
                currentTab === tab.key
                  ? "bg-white text-black shadow-sm"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => handleTabChange(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Section - Render based on Query Param */}
      <div className="w-full">
        {currentTab === "profile" && <PersonalInfoForm />}
        {currentTab === "security" && <SecuritySettings />}
      </div>
    </div>
  );
};

export default Setting;